'use client'

import { type FC } from 'react'
import { useHits } from 'react-instantsearch'

import { type AlgoliaProxyRecord } from '../../../../algolia'
import { ProductVolumePricingContextProvider } from '../../../../product'
import {
  mapAlgoliaVolumeBasedPrices,
  ProductSearchResultItem,
  ProductSearchResultItemContextProvider,
  useProductSearchResultsGtmTracker,
} from '../../../../product-search'

export const StoryblokBrandProductSearchResults: FC = () => {
  const { items, results } = useHits<AlgoliaProxyRecord>()

  useProductSearchResultsGtmTracker(results)

  return (
    <ul className="grid gap-9">
      {items.map((item) => (
        <li key={item.id}>
          <ProductSearchResultItemContextProvider algoliaRecord={item}>
            <ProductVolumePricingContextProvider
              currentVariant={item}
              volumeBasedPrices={mapAlgoliaVolumeBasedPrices(
                item.best_offer?.volume_based_prices ?? [],
              )}
            >
              <ProductSearchResultItem />
            </ProductVolumePricingContextProvider>
          </ProductSearchResultItemContextProvider>
        </li>
      ))}
    </ul>
  )
}
